/* eslint-disable camelcase */
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@material-ui/core';

interface WarningTimerDialogProps {
  open: boolean;
  onClose: () => void;
  onSave?: () => void;
  titleHeader: string;
  contentBody: string | React.ReactElement;
  cancelBtnText: string;
  confirmBtnText?: string;
}

const WarningTimerDialog: React.FC<WarningTimerDialogProps> = ({
  open,
  onClose,
  onSave,
  titleHeader,
  contentBody,
  cancelBtnText,
  confirmBtnText
}) => {
  const renderDialogTitle = () => {
    return <div>{titleHeader}</div>;
  };

  const renderDialogContent = () => {
    return <div>{contentBody}</div>;
  };
  const renderButtons = () => {
    return (
      <div>
        <Button
          style={{
            height: '3.25rem',
            width: '14rem',
            fontSize: '1.25rem',
            textTransform: 'capitalize',
            marginRight: '8px'
          }}
          onClick={() => {
            onClose();
          }}>
          {cancelBtnText}
        </Button>
        <Button
          style={{
            height: '3.25rem',
            width: '14rem',
            fontSize: '1.25rem',
            textTransform: 'capitalize',
            marginRight: '8px'
          }}
          type="submit"
          variant={'contained'}
          onClick={() => {
            onClose();
            if (onSave) onSave();
          }}
          color="primary">
          {confirmBtnText}
        </Button>
      </div>
    );
  };

  return (
    <Dialog
      disableEnforceFocus
      maxWidth={'sm'}
      fullWidth={true}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      open={open}
      onClose={onClose}
      aria-labelledby="enrollment-dialog-title">
      <DialogTitle
        disableTypography
        id="enrollment-dialog-title"
        style={{fontSize: '1.5rem'}}>
        {renderDialogTitle()}
      </DialogTitle>
      <DialogContent dividers>{renderDialogContent()}</DialogContent>
      <DialogActions style={{display: 'flex', marginRight: '1rem'}}>
        {renderButtons()}
      </DialogActions>
    </Dialog>
  );
};

export default WarningTimerDialog;
